// * Ref: https://www.notion.so/rotate/Google-Tag-Manager-98ffca4f67794f42ab088f0949111f80

const gtmVariantUrl = sku => `https://www.sungod.co/shop/redirect?sku=/${sku}`

const gtmVariantImage = (sku) => {
  if (!sku) return ''

  return `https://dynamic.sungod.co/?sku=${sku}&height=1600&width=1600&bg=transparent&image_number=5&scale=1.3`
}

// Get discount data from order
const gtmCheckoutDiscounts = (store) => {
  // Only one coupon code can be active at a time
  const couponCode = store.getters['cart/coupon']

  // But multiple coupons can be active, eg if there is a promo. Find the one which is active.
  const couponDetails = store.getters['cart/coupons'].find(coupon => coupon.type === '2' && coupon.code && coupon.code === couponCode)

  const discounts = couponCode ? [couponCode] : []
  const discountsValues = couponDetails
    ? [{
        code: couponDetails.code,
        type: couponDetails.action,
        value: parseFloat(couponDetails.discount_amount)
        // base_value: gtmPriceToFixed(cart.discount_amount_float),
      }]
    : []

  return { discounts, discountsValues }
}

// Generate default GTM payload products key value
const gtmProductsData = (items, store) => {
  const productsData = items.map((item) => {
    return {
      id: item.sku,
      name: store.getters['product/productName'](item.sku, false),
      brand: 'SunGod',
      category: (item.sku || '').split('-')[0],
      sku: item.sku,
      fbNormalisedSku: store.getters['product/normaliseSKUForFacebook'](item.sku),
      variant_id: item.sku,
      variant_name: store.getters['product/productName'](item.sku, false),
      quantity: item.qty || 1,
      price: item.price || store.getters['product/priceFromSku'](item.sku),
      compare_at_price: item.price || store.getters['product/priceFromSku'](item.sku),
      image_url: gtmVariantImage(item.sku),
      url: gtmVariantUrl(item.sku)
      // base_price: item.price,
      // base_compare_at_price: item.compare_at_price,
    }
  })
  return productsData
}

// Generate default GTM payload checkout key value
const gtmCheckoutData = (store) => {
  const quote = store.getters['cart/quote']
  const shippingCost = store.getters['cart/hasFreeShipping'] ? 0 : store.getters['store/shippingCost']

  const checkoutData = {
    order_number: parseInt(quote.entity_id),
    total_price: quote.subtotal_with_discount + shippingCost,
    // base_total_price: totalAmountWithTaxesFloat && gtmPriceToFixed(totalAmountWithTaxesFloat),
    subtotal_price: quote.subtotal_with_discount,
    // base_subtotal_price: subtotalAmountFloat && gtmPriceToFixed(subtotalAmountFloat),
    shipping_price: shippingCost,
    // base_shipping_price: shippingAmountFloat && gtmPriceToFixed(shippingAmountFloat),
    tax_price: 0,
    // base_tax_price: totalTaxAmountFloat && gtmPriceToFixed(totalTaxAmountFloat),
    discounts: gtmCheckoutDiscounts(store).discounts,
    discounts_values: gtmCheckoutDiscounts(store).discountsValues,
    customer: store.getters['store/email'],
    url: `https://www.sungod.co/checkout/cart?sg18pid=${store.getters['store/sg18pid']}`
  }

  return checkoutData
}

// Generate default GTM ecommerce payload
const gtmEcommercePayload = (items, store) => {
  return {
    ecommerce: {
      base_currency: 'GBP',
      currency: store.getters['store/currency'],
      products: gtmProductsData(items, store),
      checkout: gtmCheckoutData(store)
    }
  }
}

// Tracking functions
const track = (store, $gtm) => {
  return {
    ecommerce: {
      addToCart (items = []) {
        const trackPayload = gtmEcommercePayload(items, store)
        if ($gtm) {
          $gtm.push({
            event: 'eec.add',
            ...trackPayload,
            custom: { addToCartLocation: store.state.route.path }
          })
        }
      },

      removeFromCart (items = []) {
        const trackPayload = gtmEcommercePayload(items, store)

        if ($gtm) $gtm.push({ event: 'eec.remove', ...trackPayload })
      },

      viewProductPage (items = []) {
        const trackPayload = gtmEcommercePayload(items, store)

        if ($gtm) $gtm.push({ event: 'eec.view', ...trackPayload })
      },

      checkoutStart () {
        const trackPayload = gtmEcommercePayload(store.getters['checkout/items'], store)

        if ($gtm) {
          $gtm.push({
            event: 'eec.checkout_initiation',
            ...trackPayload,
            action: {
              step: 1
            }
          })
        }
      },

      checkoutStep (step) {
        const trackPayload = gtmEcommercePayload(store.getters['checkout/items'], store)

        trackPayload.ecommerce.checkout = {
          ...trackPayload.ecommerce.checkout,
          action: { step }
        }

        if ($gtm) $gtm.push({ event: 'eec.checkout_step', ...trackPayload })
      },

      checkoutCompletion (checkoutData) {
        const trackPayload = gtmEcommercePayload(store.getters['checkout/items'], store)
        
        trackPayload.ecommerce.checkout = {
          ...trackPayload.ecommerce.checkout,
          ...checkoutData
        }

        if ($gtm) $gtm.push({ event: 'eec.checkout_completion', ...trackPayload })
      }
    },

    form: {
      submission (type) {
        const capitalize = (s) => {
          if (typeof s !== 'string') return ''

          return s.charAt(0).toUpperCase() + s.slice(1)
        }

        const trackPayload = {
          form: {
            country: 'UK'
          }
        }
        if ($gtm) {
          $gtm.push({
            event: `form.submit${capitalize(type)}`,
            ...trackPayload
          })
        }
      }
    },

    page: {
      view ({ type, slug }) {
        if ($gtm) {
          $gtm.push({
            event: 'page.view',
            page: { type, slug }
          })
        }
      }
    }
  }
}

export default ({ store, $gtm, app, $config }, inject) => {
  inject('track', track(store, $gtm))

  app.router.afterEach((to) => {
    setTimeout(() => {
      $gtm.push(to.gtm || {
        routeName: to.name,
        pageType: 'PageView',
        pageUrl: to.fullPath,
        pageTitle: (typeof document !== 'undefined' && document.title) || '',
        event: 'nuxtRoute',
        branch: $config.branch || 'unknown'
      })
    }, 250)
  })
}
